import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// Official 2025/2026 brand-accurate social media glyphs (inline SVG).
// Sized via h-5 w-5 to match the previous lucide icons exactly.
const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      fill="#0A66C2"
      d="M19 0H5a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5zM8 19H5V8h3v11zM6.5 6.73a1.78 1.78 0 1 1 0-3.55 1.78 1.78 0 0 1 0 3.55zM20 19h-3v-5.6c0-3.37-4-3.12-4 0V19h-3V8h3v1.77c1.4-2.59 7-2.78 7 2.47V19z"
    />
  </svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      fill="#FF0000"
      d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z"
    />
    <path fill="#fff" d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      fill="#000"
      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z"
    />
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    {/* Cyan offset (back) */}
    <path
      fill="#25F4EE"
      d="M18.59 5.69a4.83 4.83 0 0 1-3.77-4.25V1H11.37v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V8.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 4.8 19.1a6.34 6.34 0 0 0 10.86-4.43V7.79a8.16 8.16 0 0 0 4.77 1.52V5.94a4.85 4.85 0 0 1-1.84-.25z"
    />
    {/* Red offset */}
    <path
      fill="#FE2C55"
      d="M20.59 7.69a4.83 4.83 0 0 1-3.77-4.25V3H13.37v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13v-3.5a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 6.8 21.1a6.34 6.34 0 0 0 10.86-4.43V9.79a8.16 8.16 0 0 0 4.77 1.52V7.94a4.85 4.85 0 0 1-1.84-.25z"
    />
    {/* Black main */}
    <path
      fill="#000"
      d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2H12.37v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.79a8.16 8.16 0 0 0 4.77 1.52V6.94a4.85 4.85 0 0 1-1.84-.25z"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <radialGradient id="ig-grad-footer" cx="0.3" cy="1" r="1.25">
        <stop offset="0" stopColor="#FFD600" />
        <stop offset="0.25" stopColor="#FF7A00" />
        <stop offset="0.5" stopColor="#FF0069" />
        <stop offset="0.75" stopColor="#D300C5" />
        <stop offset="1" stopColor="#7638FA" />
      </radialGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#ig-grad-footer)" />
    <path
      fill="#fff"
      d="M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 8.2a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4z"
    />
    <circle cx="17.6" cy="6.4" r="1.2" fill="#fff" />
  </svg>
);

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Smooth-scroll to the hero (top) of the destination page.
  // Same-page click → smooth scroll to top.
  // Cross-page click → navigate, then snap to top on the next frame so
  // the new page lands precisely at its hero section on load.
  const handleOverviewClick = (e, href) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (location.pathname === href) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate(href);
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      });
    }
  };

  return (
    <footer className="w-full bg-[#F5F7F5] mt-auto">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {/* Top section with logo */}
        <div className="flex items-center mb-8 md:mb-12">
          <div className="text-3xl md:text-4xl font-medium text-black/90">
            GoogLyn AI
          </div>
        </div>

        {/* Main footer grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-10 md:mb-16">
          {/* Overview Column */}
          <div>
            <h3 className="text-sm md:text-base font-light text-black/40 mb-4 md:mb-6 uppercase tracking-wider">Overview</h3>
            <ul className="space-y-3 md:space-y-4">
              <li>
                <Link to="/product/ai-concierge" onClick={(e) => handleOverviewClick(e, '/product/ai-concierge')} className="text-sm md:text-base text-black/70 hover:text-[#E8A0B8] transition-colors font-light">
                  AI Concierge
                </Link>
              </li>
              <li>
                <Link to="/product/broadcast-commercials" onClick={(e) => handleOverviewClick(e, '/product/broadcast-commercials')} className="text-sm md:text-base text-black/70 hover:text-[#E8A0B8] transition-colors font-light">
                  Broadcast Commercials
                </Link>
              </li>
              <li>
                <Link to="/product/ai-app-builder" onClick={(e) => handleOverviewClick(e, '/product/ai-app-builder')} className="text-sm md:text-base text-black/70 hover:text-[#E8A0B8] transition-colors font-light">
                  AI App Builder
                </Link>
              </li>
              <li>
                <a href="https://googlyn.ca/products/ai-employee" className="text-sm md:text-base text-black/70 hover:text-[#E8A0B8] transition-colors font-light">
                  AI Employee
                </a>
              </li>
              <li>
                <Link to="/product/enterprise-solutions" onClick={(e) => handleOverviewClick(e, '/product/enterprise-solutions')} className="text-sm md:text-base text-black/70 hover:text-[#E8A0B8] transition-colors font-light">
                  Enterprise Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-sm md:text-base font-light text-black/40 mb-4 md:mb-6 uppercase tracking-wider">Company</h3>
            <ul className="space-y-3 md:space-y-4">
              <li>
                <Link to="/about" className="text-sm md:text-base text-black/70 hover:text-[#E8A0B8] transition-colors font-light">
                  About
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-sm md:text-base text-black/70 hover:text-[#E8A0B8] transition-colors font-light">
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          {/* Terms & Policies Column */}
          <div>
            <h3 className="text-sm md:text-base font-light text-black/40 mb-4 md:mb-6 uppercase tracking-wider">Terms & Policies</h3>
            <ul className="space-y-3 md:space-y-4">
              <li>
                <Link
                  to="/legal/terms-of-service"
                  onClick={(e) => handleOverviewClick(e, '/legal/terms-of-service')}
                  className="text-sm md:text-base text-black/70 hover:text-[#E8A0B8] transition-colors font-light"
                  data-testid="footer-link-terms-of-service"
                >
                  Terms Of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/privacy-policy"
                  onClick={(e) => handleOverviewClick(e, '/legal/privacy-policy')}
                  className="text-sm md:text-base text-black/70 hover:text-[#E8A0B8] transition-colors font-light"
                  data-testid="footer-link-privacy-policy"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/cookie-policy"
                  onClick={(e) => handleOverviewClick(e, '/legal/cookie-policy')}
                  className="text-sm md:text-base text-black/70 hover:text-[#E8A0B8] transition-colors font-light"
                  data-testid="footer-link-cookie-policy"
                >
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Column */}
          <div>
            <h3 className="text-sm md:text-base font-light text-black/40 mb-4 md:mb-6 uppercase tracking-wider">Socials</h3>
            <div className="flex flex-col gap-3">
              <a 
                href="https://www.linkedin.com/company/googlyn-ai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-black/70 hover:text-[#E8A0B8] transition-colors w-fit"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
              </a>
              <a 
                href="https://www.youtube.com/@GoogLynAISolutions" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-black/70 hover:text-[#E8A0B8] transition-colors w-fit"
                aria-label="YouTube"
              >
                <YouTubeIcon />
              </a>
              <a 
                href="https://twitter.com/googlynai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-black/70 hover:text-[#E8A0B8] transition-colors w-fit"
                aria-label="X (Twitter)"
              >
                <XIcon />
              </a>
              <a 
                href="https://www.tiktok.com/@googlynai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-black/70 hover:text-[#E8A0B8] transition-colors w-fit"
                aria-label="TikTok"
              >
                <TikTokIcon />
              </a>
              <a 
                href="https://www.instagram.com/googlynai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-black/70 hover:text-[#E8A0B8] transition-colors w-fit"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom section */}
        <div className="pt-8 border-t border-black/10">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div className="text-sm text-black/50 font-light">
              Designed by Elegance. Powered by AI.
            </div>
            <div className="text-sm text-black/50 font-light">
              © {new Date().getFullYear()} GoogLyn AI. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
